import React from "react";
import { apps, wording } from "./constants";

//Carbon X
const SupplyChainEmissionDashboard = React.lazy(
  () => import("../views/CarbonX/Dashboard/SupplyChainEmission")
);

const CompanyEmissionDashboard = React.lazy(
  () => import("../views/CarbonX/Dashboard/CompanyEmission")
);

const CompanySetting = React.lazy(
  () =>
    import("../views/CarbonX/CompanyDisclosure/CompanySetting/CompanySetting")
);

const Checksheets = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/ListDisclosure/Checksheets/Checksheets"
    )
);
const Asset = React.lazy(
  () =>
    import("../views/CarbonX/CompanyDisclosure/ListDisclosure/Asset/AssetTab")
);
const HR = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/ListDisclosure/HR/HumanResources"
    )
);
const Bills = React.lazy(
  () =>
    import("../views/CarbonX/CompanyDisclosure/ListDisclosure/Bills/BillsTab")
);
const PurchasedGoodsAndServices = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/ListDisclosure/PurchasedGoodsAndServices/PurchasedGoodsAndServices"
    )
);
const ThirdPartyLogistics = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/ListDisclosure/ThirdPartyLogistics/ThirdPartyLogisticsTab"
    )
);

const OperationDisclosure = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/OperationDisclosure/OperationDisclosure"
    )
);
const AccountingDisclosure = React.lazy(
  () =>
    import(
      "../views/CarbonX/CompanyDisclosure/AccountingDisclosure/AccountingDisclosure"
    )
);

const AETDashboard = React.lazy(
  () => import("../views/CarbonX/AETDashboard/AETDashboard")
);
const AETScope1 = React.lazy(
  () => import("../views/CarbonX/AET/Scope1/Scope1Tab")
);
const AETScope2 = React.lazy(
  () => import("../views/CarbonX/AET/Scope2/Scope2Tab")
);
const AETScope3 = React.lazy(
  () => import("../views/CarbonX/AET/Scope3/Scope3Tab")
);

const EmissionFactorsTab = React.lazy(
  () => import("../views/CarbonX/EmissionFactors/EmissionFactorTab")
);

const MyData = React.lazy(
  () => import("../views/CarbonX/EmissionDatabase/MyData/MyData")
);
const DataPool = React.lazy(
  () => import("../views/CarbonX/EmissionDatabase/DataPool/DataPool")
);

const DecarbonizationPlan = React.lazy(
  () => import("../views/CarbonX/DecarbonizationPlan/DecarbonizationPlan")
);

const OffsetStewardship = React.lazy(
  () => import("../views/CarbonX/OffsetStewardship/OffsetStewardship")
);

const ReportDisclosure = React.lazy(
  () => import("../views/CarbonX/ReportDisclosure/ReportDisclosure")
);

const ESGMetric = React.lazy(() => import("../views/CarbonX/ESG/ESGMetric"));
const ESGKPI = React.lazy(() => import("../views/CarbonX/ESG/ESGKPI"));

const DO = React.lazy(
  () => import("../views/Fleet/DeliveryOrders/DeliveryOrders")
);

const ThreePL = React.lazy(
  () => import("../views/Fleet/3PL/Administrative/TriPLAdministrative")
);

const Fleets = React.lazy(() => import("../views/Fleet/Fleets/Fleets"));

const FleetsOperations = React.lazy(
  () => import("../views/Fleet/FleetOperations/FleetOperations")
);

export const routes = [
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/dashboard/supplychainemission",
    name: "Supply Chain Emission",
    Component: SupplyChainEmissionDashboard,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/dashboard/companyemission",
    name: "Company Emission",
    Component: CompanyEmissionDashboard,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/companydisclosure/companysetting",
    name: "Company Setting",
    Component: CompanySetting,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/checksheets",
    name: "Checksheets",
    Component: Checksheets,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/asset",
    name: "Asset",
    Component: Asset,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/hr",
    name: "HR",
    Component: HR,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/bills",
    name: "Bills",
    Component: Bills,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/purchasedgoodsandservices",
    name: "Purchased Goods and Service",
    Component: PurchasedGoodsAndServices,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/listdisclosure/thirdpartylogistics",
    name: "Third Party Logistics",
    Component: ThirdPartyLogistics,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/companydisclosure/operationdisclosure",
    name: "Operation Disclosure",
    Component: OperationDisclosure,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/companydisclosure/accountingdisclosure",
    name: "Accounting Disclosure",
    Component: AccountingDisclosure,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/AET/AETDashboard",
    name: "AET Dashboard",
    Component: AETDashboard,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/AET/scope1",
    name: "AET Scope 1",
    Component: AETScope1,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/AET/scope2",
    name: "AET Scope 2",
    Component: AETScope2,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/AET/scope3",
    name: "AET Scope 3",
    Component: AETScope3,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/emissionfactors",
    name: "Emission Factors",
    Component: EmissionFactorsTab,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/emissiondatabase/mydata",
    name: "My Data",
    Component: MyData,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/emissiondatabase/datapool",
    name: "Data Pool",
    Component: DataPool,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/decarbonizationplan",
    name: "Decarbonization Plan",
    Component: DecarbonizationPlan,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/offsetstewardship",
    name: "Offset and Stewardship",
    Component: OffsetStewardship,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/reportdisclosure",
    name: "Report Disclosure",
    Component: ReportDisclosure,
    exact: true,
  },

  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/esgmetric/:category/:menu",
    name: "ESG Metric & Indicator",
    Component: ESGMetric,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/carbonx/esgkpi/:menu",
    name: "ESG KPI",
    Component: ESGKPI,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/trackx/do",
    name: wording["Delivery Order"] + "s",
    Component: DO,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/trackx/3pladministrative",
    name: "3PL Administrative",
    Component: ThreePL,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/trackx/fleets",
    name: "Fleets",
    Component: Fleets,
    exact: true,
  },
  {
    files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
    path: "/trackx/fleetsoperations",
    name: "Fleets Operations",
    Component: FleetsOperations,
    exact: true,
  },
];

interface IMenu {
  name: string;
  url: string;
  icon: string | null;
  children?: IMenu[];
}

type IRemoveIcon = (item: IMenu) => IMenu;

const removeIcon: IRemoveIcon = (a) => {
  if (!!a.children) {
    return { ...a, children: a.children.map(removeIcon), icon: null };
  }

  return { ...a, icon: null };
};

export const menu = [
  {
    name: "ESG Metric & Indicator",
    url: "/carbonx/esgmetric/",
    icon: "fa fa-line-chart",
    files: ["_nav.js"],
    children: [
      {
        name: "Environmental",
        url: "/carbonx/esgmetric/environmental/",
        icon: "",
        files: ["_nav.js"],
        children: [
          {
            name: "Climate Action",
            url: "/carbonx/esgmetric/environmental/climateaction",
            icon: "",
            files: ["_nav.js"],
          },
          {
            name: "Waste Resource Management",
            url: "/carbonx/esgmetric/environmental/wasteresourcemanagement",
            icon: "",
            files: ["_nav.js"],
          },
        ],
      },
      {
        name: "Social",
        url: "/carbonx/esgmetric/social/",
        icon: "",
        files: ["_nav.js"],
        children: [
          {
            name: "Talent Development & Growth",
            url: "/carbonx/esgmetric/social/talentdevelopmentgrowth",
            icon: "",
            files: ["_nav.js"],
          },
          {
            name: "Digital Responsibility & Inclusion",
            url: "/carbonx/esgmetric/social/digitalresponsibility",
            icon: "",
            files: ["_nav.js"],
          },
          {
            name: "Customer Engagement",
            url: "/carbonx/esgmetric/social/customerengagement",
            icon: "",
            files: ["_nav.js"],
          },
        ],
      },
      {
        name: "Governance",
        url: "/carbonx/esgmetric/governance/",
        icon: "",
        files: ["_nav.js"],
        children: [
          {
            name: "Risk Management",
            url: "/carbonx/esgmetric/governance/riskmanagement",
            icon: "",
            files: ["_nav.js"],
          },
          {
            name: "Value & Compliance",
            url: "/carbonx/esgmetric/governance/valuecompliance",
            icon: "",
            files: ["_nav.js"],
          },
        ],
      },
    ],
  },
  {
    name: "ESG KPI",
    url: "/carbonx/esgkpi/",
    icon: "fa fa-bar-chart",
    files: ["_nav.js"],
    children: [
      {
        name: "Ratings and Certifications",
        url: "/carbonx/esgkpi/ratingandcertifications",
        icon: "",
        files: ["_nav.js"],
      },
      {
        name: "Risk and Financial Performance",
        url: "/carbonx/esgkpi/riskfinancialperformance",
        icon: "",
        files: ["_nav.js"],
      },
      {
        name: "Targets and Progress",
        url: "/carbonx/esgkpi/targetprogress",
        icon: "",
        files: ["_nav.js"],
      },
      {
        name: "Enabler Performance",
        url: "/carbonx/esgkpi/enablerperformance",
        icon: "",
        files: ["_nav.js"],
      },
      {
        name: "Supplier Engagement",
        url: "/carbonx/esgkpi/supplierengagement",
        icon: "",
        files: ["_nav.js"],
      },
    ],
  },
  ...(apps === "carbon_ethics" || apps === "stark_industries"
    ? [
        {
          name: "TrackX",
          url: "/trackx/",
          icon: "truck icon",
          files: ["_nav.js"],
          children: [
            {
              name: wording["Delivery Order"] + "s",
              url: "/trackx/do",
              icon: "truck icon",
              files: ["_nav.js"],
            },
            {
              name: "3PL Administrative",
              url: "/trackx/3pladministrative",
              icon: "clipboard check icon",
              files: ["_nav.js"],
            },
            {
              name: "Fleets",
              url: "/trackx/fleets",
              icon: "truck icon",
              files: ["_nav.js"],
            },
            {
              name: "Fleets Operations",
              url: "/trackx/fleetsoperations",
              icon: "shipping fast icon",
              files: ["_nav.js"],
            },
          ],
        },
      ]
    : []),
  {
    name: "CarbonX",
    url: "/carbonx/",
    icon: "leaf icon",
    files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
    children: [
      {
        name: "CarbonX Dashboard",
        url: "/carbonx/dashboard/",
        icon: "tachometer alternate icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
        children: [
          {
            name: "Supply Chain Emission",
            url: "/carbonx/dashboard/supplychainemission",
            icon: "truck icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Company Emission",
            url: "/carbonx/dashboard/companyemission",
            icon: "industry icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
        ],
      },
      {
        name: "Company Disclosure",
        url: "/carbonx/companydisclosure/",
        icon: "building icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
        children: [
          {
            name: "Company Setting",
            url: "/carbonx/companydisclosure/companysetting",
            icon: "cogs icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "List Disclosure",
            url: "/carbonx/companydisclosure/listdisclosure",
            icon: "list alternate icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            children: [
              {
                name: "Checksheets",
                url: "/carbonx/listdisclosure/checksheets",
                icon: "check square icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Asset",
                url: "/carbonx/listdisclosure/asset",
                icon: "briefcase icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "HR",
                url: "/carbonx/listdisclosure/hr",
                icon: "users icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Bills",
                url: "/carbonx/listdisclosure/bills",
                icon: "money bill alternate icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Purchased Goods and Service",
                url: "/carbonx/listdisclosure/purchasedgoodsandservices",
                icon: "dolly flatbed icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Third Party Logistics",
                url: "/carbonx/listdisclosure/thirdpartylogistics",
                icon: "warehouse icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Produced Goods",
                url: "/carbonx/listdisclosure/producedgoods",
                icon: "box icon",
                files: ["_nav.js"],
              },
              {
                name: "Waste",
                url: "/carbonx/listdisclosure/waste",
                icon: "trash alternate icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
            ],
          },
          {
            name: "Operation Disclosure",
            url: "/carbonx/companydisclosure/operationdisclosure/",
            icon: "cog icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            children: [
              {
                name: "Office & Commuting",
                url: "/carbonx/operationdisclosure/officeandcommuting",
                icon: "building icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Logistics and Manufacturing",
                url: "/carbonx/operationdisclosure/logisticsanfmanufacturing",
                icon: "boxes icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Business Travel",
                url: "/carbonx/operationdisclosure/businesstravel",
                icon: "truck icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Land Use",
                url: "/carbonx/operationdisclosure/landuse",
                icon: "check square icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
            ],
          },
          {
            name: "Accounting Disclosure",
            url: "/carbonx/companydisclosure/accountingdisclosure/",
            icon: "fa fa-calculator",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
            children: [
              {
                name: "Balanced Sheets",
                url: "/carbonx/accountingdisclosure/balancedsheets",
                icon: "balance scale icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
              {
                name: "Cashflows",
                url: "/carbonx/accountingdisclosure/cashflow",
                icon: "money bill alternate icon",
                files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
              },
            ],
          },
        ],
      },
      {
        name: "Automatic Emission Tracking",
        url: "/carbonx/AET/",
        icon: "cogs icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
        children: [
          {
            name: "AET Dashboard",
            url: "/carbonx/AET/AETDashboard",
            icon: "fa fa-tachometer",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Scope 1",
            url: "/carbonx/AET/scope1",
            icon: "industry icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Scope 2",
            url: "/carbonx/AET/scope2",
            icon: "bolt icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Scope 3",
            url: "/carbonx/AET/scope3",
            icon: "truck icon",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Carbon Invoice",
            url: "/carbonx/invoice",
            icon: "fa fa-file-text-o",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
        ],
      },
      {
        name: "Emission Factors",
        url: "/carbonx/emissionfactors",
        icon: "cloud download icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
      },
      {
        name: "Emission Database",
        url: "/carbonx/emissiondatabase/",
        icon: "database icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
        children: [
          {
            name: "My Data",
            url: "/carbonx/emissiondatabase/mydata",
            icon: "fa fa-bar-chart",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
          {
            name: "Data Pool",
            url: "/carbonx/emissiondatabase/datapool",
            icon: "fa fa-table",
            files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
          },
        ],
      },
      {
        name: "Decarbonization Plan",
        url: "/carbonx/decarbonizationplan",
        icon: "leaf icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
      },
      {
        name: "Offset and Stewardship",
        url: "/carbonx/offsetstewardship",
        icon: "fax icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
      },
      {
        name: "Report Disclosure",
        url: "/carbonx/reportdisclosure",
        icon: "file alternate icon",
        files: ["_nav.js", "goodsTraderIntercompanyNav.jsx"],
      },
    ],
  },
];

export const menuWithoutIcon = menu.map(removeIcon);
export const menuOnlyParentsWithIcon = menu.map((item) => {
  if (!!item.children) {
    return { ...item, children: item.children.map(removeIcon) };
  }

  return { ...item };
});
